import { render, staticRenderFns } from "./MerchantDialog.vue?vue&type=template&id=184c99a2&scoped=true&"
import script from "./MerchantDialog.vue?vue&type=script&lang=js&"
export * from "./MerchantDialog.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDialog.vue?vue&type=style&index=0&id=184c99a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c99a2",
  null
  
)

export default component.exports